// extracted by mini-css-extract-plugin
export var authorInfos = "ArticleAuthor-module--authorInfos--a064c";
export var authorName = "ArticleAuthor-module--authorName--77f59";
export var authorPhoto = "ArticleAuthor-module--authorPhoto--70316";
export var authorTextBox = "ArticleAuthor-module--authorTextBox--cb7f4";
export var authorWrapper = "ArticleAuthor-module--authorWrapper--99c47";